export default {
  title: '订单明细',
  height: 'auto',
  calcHeight: 'auto',
  tip: false,
  border: true,
  index: true,
  indexLabel: '序号',

  viewBtn: false,
  selection: true,
  showSummary: true,
  sumColumnList: [
    {
      name: 'totalFee',
      type: 'sum',
    },
    {
      name: 'settlementRefundFee',
      type: 'sum',
    },
    {
      name: 'refundFee',
      type: 'sum',
    },
  ],
  cellBtn: true,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  columnBtn: false,
  refreshBtn: false,
  menu: false,
  column: [
    {
      label: '业务订单号',
      prop: 'orderNo',
      rules: [
        {
          required: true,
          message: '请输入业务订单号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '商品分类',
      prop: 'goodsType',
      width: 100,
      rules: [
        {
          required: true,
          message: '请输入商品分类',
          trigger: 'change',
        },
      ],
    },
    {
      label: '商品名称',
      prop: 'goodsName',
      rules: [
        {
          required: true,
          message: '请输入商品名称',
          trigger: 'change',
        },
      ],
    },
    {
      label: '交易状态',
      prop: 'tradeStatus',

      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=tradeStatus',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      width: 100,
      rules: [
        {
          required: true,
          message: '请输入交易状态',
          trigger: 'change',
        },
      ],
    },
    {
      label: '订单金额(元)',
      prop: 'totalFee',
      width: 120,
      rules: [
        {
          required: true,
          message: '请输入订单金额(元)',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退款申请合计(元)',
      prop: 'settlementRefundFee',
      rules: [
        {
          required: true,
          message: '请输入退款申请合计金额(元)',
          trigger: 'change',
        },
      ],
    },
    {
      label: '本次退款申请金额(元)',
      prop: 'refundFee',
      cell: true,
      rules: [
        {
          required: true,
          message: '请输入本次退款申请金额(元)',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退款原因',
      prop: 'refundDesc',
      type: 'textarea',
      cell: true,
      rules: [
        {
          required: true,
          message: '请输退款原因',
          trigger: 'change',
        },
      ],
    },
  ],
};
